/**
 * @generated SignedSource<<16f8f22ce5cd7c52eec8c43fde762804>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InlineDescriptionV2_organization$data = {
  readonly description: string | null;
  readonly " $fragmentType": "InlineDescriptionV2_organization";
};
export type InlineDescriptionV2_organization$key = {
  readonly " $data"?: InlineDescriptionV2_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"InlineDescriptionV2_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InlineDescriptionV2_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "c5927d5d31eda2fa684a1b65355b417d";

export default node;
